module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/cover-description-a2e810877ef2bc4356db2d845b987472.svg";